import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';

export default function AuthCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { setAuthTokens } = useAuth();
  const [status, setStatus] = useState('Processing authentication...');

  useEffect(() => {
    const token = searchParams.get('token');
    const refresh = searchParams.get('refresh');
    const error = searchParams.get('error');

    if (error) {
      setStatus(`Authentication failed: ${error}`);
      setTimeout(() => navigate('/signin'), 3000);
      return;
    }

    if (token && refresh) {
      // Store tokens and redirect to dashboard
      setAuthTokens(token, refresh);
      setStatus('Authentication successful! Redirecting...');
      setTimeout(() => navigate('/dashboard'), 500);
    } else {
      setStatus('Invalid callback. Redirecting to login...');
      setTimeout(() => navigate('/signin'), 2000);
    }
  }, [searchParams, navigate, setAuthTokens]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4">
      <div className="text-center">
        <div className="mb-8">
          <span className="text-emerald-500 font-mono font-bold text-xl">
            <span className="text-cyan-400">{'>'}</span>_ClawStinger
          </span>
        </div>
        
        <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-8 max-w-md">
          <div className="animate-pulse mb-4">
            <div className="w-12 h-12 mx-auto border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
          <p className="text-zinc-300 font-mono text-sm">{status}</p>
        </div>
      </div>
    </div>
  );
}
